const Images = {
  logo: require("../assets/img/sabka-vaidya-logo.svg").default,
  kidney: require("../assets/img/kidney-failure.png"),
  pain: require("../assets/img/pain-mgmt.png"),
  disease: require("../assets/img/disease.png"),
  blogs: require("../assets/img/blogs.png"),
  medicine: require("../assets/img/buy-medicine.png"),
  healing: require("../assets/img/healing-stories.png"),
  firstSlider: require("../assets/img/sbka-vaidya-banner.jpg"),
  secondSlider: require("../assets/img/sbka-vaidya-banner-2.jpg"),
  clinic: require("../assets/img/clinicIcon.svg").default,
  chat: require("../assets/img/chatIcon.svg").default,
  video: require("../assets/img/videoIcon.svg").default,
  phone: require("../assets/img/callIcon.svg").default,
  chatForm: require("../assets/img/chatForm.jpg"),
  DnaBanner: require("../assets/img/dna-protocol.jpg"),
  AadiClinic: require("../assets/img/aadi-clinic.jpg"),
  painMgmt: require("../assets/img/pain-management.png"),
  skinDisease: require("../assets/img/skin-disease.png"),
  lifeDisorder: require("../assets/img/life-style-dis-order.png"),
  digestiveIssues: require("../assets/img/digestive-issue.png"),
  KidneyFailure: require("../assets/img/Kidney.png"),
  topKidneyBanner: require("../assets/img/top-banner-kidney-failure.jpg"),
  middleKidneyBanner: require("../assets/img/kidney-failure-middle.jpg"),
  lowerKidneyBanner: require("../assets/img/kidney-lower-banner.jpg"),
  topPainBanner: require("../assets/img/pain-mgmt-top-banner.jpg"),
  middlePainBanner: require("../assets/img/pain-mgmt-middle-banner.jpg"),
  lowerPainBanner: require("../assets/img/pain-mgmt-lower-banner.jpg"),
  noData: require("../assets/img/noData.png"),
  notFound: require("../assets/img/not-found-image.png"),
  defaultUser: require("../assets/img/doctor-default-user.jpg"),
  drAbhishek: require("../assets/img/Dr.Abhishek.jpeg"),
  loginBg: require("../assets/img/loginBg.jpeg"),
  herbs: require("../assets/img/herbs.png"),
  news: require("../assets/img/health.png"),
  spiritual: require("../assets/img/spiritual.png"),
  videos: require("../assets/img/videos.png"),
  department: require("../assets/img/department.png"),
  bottomLogo: require("../assets/img/bottom-logo.png"),
  consultancyBanner: require("../assets/img/consultancy-banner.jpg"),
  appointmentImg: require("../assets/img/appointment-form.jpg"),
  videoConsult: require("../assets/img/Apply_now.svg").default,
  fixedPhone: require("../assets/img/phone.svg").default,
  kidneyFrontPage: require("../assets/img/kidney-front-page.png"),
  clinicBanner: require("../assets/img/video-consult-banner.png"),
  OurServices: {
    buyMedicine: require("../assets/img/buy-medicine.svg").default,
    healingStories: require("../assets/img/healing-stories.svg").default,
    blogs: require("../assets/img/blogs.svg").default,
    videosForm: require("../assets/img/Videos.svg").default,
  },
};
export default Images;
